/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://ae6kng6lhveexgy6bfqbzlen3i.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:2c356692-7a32-489e-bfc5-d0dad8c23435",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_U02lTeoMw",
    "aws_user_pools_web_client_id": "7t4hi7voq273tecakpuamdqc5g",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "mcchubdashboard-hostingbucket-devhub",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://db8n940eusb4f.cloudfront.net"
};


export default awsmobile;
